import * as yup from "yup";
import { getValidationSchema } from "../../../../shared/validations/schema";
import regularExpressions from "../../../../shared/validations/regularExpression";
export const customizeValidationSchema = () => {
  let defaultSchema: any = getValidationSchema([
    "phone",
    "email",
    "subdomainName",
  ]);

  let customSchema = yup.object().shape({
    name: yup
      .string()
      .trim("Company Name cannot include leading and trailing spaces")
      .strict(true)
      .min(2, "Company Name must be more than 2 characters")
      .max(250, "Company Name cannot exceed more than 250 characters")
      .required("Company Name is a required field")
      .matches(
        regularExpressions.alphaNumericsWithLimitedSpecialCharacter,
        "Company name can only include letters, numbers, spaces, and the characters & . ' -"
      )
      .test(
        "no-consecutive-spaces",
        "Company name cannot have consecutive spaces.",
        (value) => !/\s{2,}/.test(value)
      ),
      phone: yup
      .string()
      .strict(true)
      .matches(/^[0-9]+$/, "Phone must only contain digits")
      .matches(/^(?!0+$)/, "Phone number cannot be all zeroes")
      .min(10, "Phone must be 10 characters")
      .max(10, "Phone must be 10 characters")
      .required("Phone is a required field"),
  });

  return defaultSchema.concat(customSchema);
};

export const customizeServiceValidationSchema = () => {
  let defaultSchema: any = getValidationSchema([]);

  let customSchema = yup.object().shape({
    serviceID: yup.string().required("Service is a required field"),
  });
  return defaultSchema.concat(customSchema);
};
export const customizeDomainValidationSchema = () => {
  let defaultSchema: any = getValidationSchema([]);

  let customSchema = yup.object().shape({
    domainName: yup
      .string()
      .trim("Domain Name cannot include leading and trailing spaces")
      .strict(true)
      .matches(
        regularExpressions.domainName,
        "Domain Name must be a valid domain (e.g., example.com)."
      )
      .required("Domain Name is a required field"),
  });
  return defaultSchema.concat(customSchema);
};
